export const OPEN_HAMBURGER_MENU = "OPEN_HAMBURGER_MENU";
export const OPEN_SEARCHBAR = "OPEN_SEARCHBAR";
export const MEMBER_UPDATED = "MEMBER_UPDATED";
export const IS_OPEN_LOGIN_FORM = "IS_OPEN_LOGIN_FORM";
export const OUR_VIEW_OPEN = "OUR_VIEW_OPEN";
export const FIREBASE_USER = "FIREBASE_USER";
export const SUBSCRIBED_USER = "SUBSCRIBED_USER";
export const USER_PROFILE_ID = "USER_PROFILE_ID";
export const BOOKMARK_DATA = "BOOKMARK_DATA";
